import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  #scene{
    position: relative;
    div {
     user-select: none;
     -webkit-user-select: none;
     -moz-user-select: none;
     -ms-user-select: none;
   }
  }
`;
